
<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="app" >
        <br />

        <div style="display:flex;place-content:center">
        <img
          style="
            max-width: 300px;
            max-height: 250px;
            width: 300px;
            height: 250px;
            object-fit: cover;
          "
          v-show="!errorImage"
          v-bind:src="urlImageProduto(contrato, product.cd)"
          v-bind:alt="product.cd"
          @load="errorImage= false"
          @error="errorImage = true"
        />
        </div>

        <div :style="{color: corTexto}">
          <table class="table" >
            <thead>
              <tr>
                <th scope="col">
                  <label class="cor-preta" :style="{color: corTexto}"><b>Produto</b></label>
                </th>
                <th scope="col" v-if="product.unitario == '0'">
                  <div style="display: flex; justify-content: center">
                    <label class="cor-preta" :style="{color: corTexto}"><b>Peso</b></label>
                  </div>
                </th>
                <th scope="col">
                  <label :style="{color: corTexto}"><b>Preço</b></label>
                </th>
              </tr>
            </thead>
            <tbody id="listarproduto()">
              <tr>
                <td>
                  <label
                  :style="{color: corTexto}"
                    ><b>{{ product.nm }}</b></label
                  >
                </td>
                <td v-if="product.unitario == '0'">
                  <input
                    type="number"
                    v-model="peso"
                    class="form-control"
                    id="text"
                    aria-describedby="textHelp"
                    placeholder="Digite o peso"
                  />
                </td>
                <td>
                  <label
                  :style="{color: corTexto}"
                    class="cor-preta"
                    style="width: 100px; word-wrap: break-word"
                    ><b>R$ {{ totalValorPeso}}</b></label
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="this.campoObsAtivo != '1' && this.campoObsAtivo != '3'">
<b>Alguma observação ?</b>
          <textarea
            class="form-control"
            v-model="obs"
            id="obs"
            name="obs"
            rows="2"
            placeholder="Ex: Digite as observações aqui..."
          ></textarea>
          </div>  
        </div>

        <div class="modal-footer">
          <button
            style="background-color: #006400"
            @click="addItem(product, adicionaispergunta,obs)"
            type="button"
            class="btn btn-dark"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<style>
.cores{
  color: corTexto;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "ProdutoUnico",
  data() {
    return {
      adicionaispergunta: [],
      obs:'',
      product: [],
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
      },
      peso: "",
      corBotao: "",
      corTexto: "",
      corFundo: "",
      corDescricao:"",
      campoObsAtivo: "0",
      somenteAgendamento: "0",
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
            contrato:"",
      errorImage:true
    };
  },
  computed: {
    totalValorPeso() {
      var valor = 0;
      if (this.peso == "") {
        return this.product.vl;
      } else {
        valor = parseFloat(this.peso) * parseFloat(this.product.vl);
        valor = valor.toFixed(2);
        return valor;
      }
    },
    ...mapGetters({
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then(resposta => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "COR_DESCRICAO";
      Inis.listarInisCd(cd).then(resposta => {
        this.corDescricao = resposta.data[0].vl;
      });
      var cd = "SOMENTE_AGENDAMENTO"
      Inis.listarInisCd(cd).then((response) => {
        this.somenteAgendamento = response.data[0].vl;
        console.log(this.somenteAgendamento)
      }).catch(() => {
        this.somenteAgendamento = "0";  
      });
      var cd = "ATIVA_OBS";
      Inis.listarInisCd(cd)
  .then(resposta => {
    const valor = resposta?.data?.[0]?.vl;
    this.campoObsAtivo = valor ?? '0';
  })
  .catch(erro => {
    console.error("Erro ao buscar configuração ATIVA_OBS:", erro);
    this.campoObsAtivo = '0';
  });
    },
    listarproduto() {
      this.product = ls.get("product" + this.contrato);
    },
    addItem(product, adicionaispergunta,obs) {
      if (this.$store.state.funcionamento === "0" && this.somenteAgendamento == "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
      } else if (obs.split('').length>250) {
        Swal.fire({
          title: "Limite de caracteres atingido",
          confirmButtonColor: "#000000",
        });
      } else if (product.unitario == "0" && this.peso == "") {
        Swal.fire({
          title: "Digite o peso em kilogramas",
          confirmButtonColor: "#000000",
        });
      } else if (this.$store.state.funcionamento === "1" || this.somenteAgendamento == "1") {
        if (product.unitario == "0") {
          /*           product.vl = this.totalValorPeso; */
          product.peso = this.peso;
        }

        this.$store.dispatch("addToCart", {
          product,
          adicionaispergunta,
          obs
        });
        this.$router.push("/cart");
      }
    },
    loadFacebookPixel(idPixel) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement('script');
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement('noscript');
      var img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=' + idPixel + '&ev=ViewContent&noscript=1';

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);

    },
    urlImageProduto(contrato, prod) {
      // return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/produtos/${prod}.jpg?${performance.now()}`;
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/produtos/${prod}.webp?${performance.now()}`;
    },
    erroImagemProduto(event,contrato) {
      event.target.src =
        "https://apppanterafood.com.br/DeliveryCenter/" +
        contrato +
        "/produtos/sem_imagem.jpg";
    },
    ...mapActions(["addToCart"]),
  },
  mounted() {
    this.contrato=localStorage.getItem("contrato")
    this.listarproduto(), this.listarinis();
  },
};
</script>